import React, { useState } from "react";
import { Radio, Input, Button, Form, message, Card, Row, Col } from "antd";
import "./AssigneSearch.css";

const AssigneSearch = () => {
  const [selectedOption, setSelectedOption] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [results, setResults] = useState([]);

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
    setInputValue("");
    setResults([]);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const fetchData = async () => {
    try {
      const type = selectedOption === "acknowledgement" ? "ACK" : "MOBILE";
      const apiUrl = `/api/portal/pms/search_pms_details_by_id?type=${type}&value=${inputValue}`;

      const response = await fetch(apiUrl);
      const data = await response.json();
      if (data.serviceResult) {
        setResults([data.serviceResult]);
      }
    } catch (error) {
      message.error("Failed to fetch data from the API");
    }
  };

  const handleSubmit = () => {
    if (inputValue) {
      fetchData();
    } else {
      message.error("Please enter a value before submitting");
    }
  };

  return (
    <div className="centered-container">
      <Form onFinish={handleSubmit} layout="vertical" className="centered-form">
        <Form.Item label="Select Type" className="centered-radio">
          <Radio.Group onChange={handleOptionChange} value={selectedOption}>
            <Radio value="acknowledgement">Acknowledgement</Radio>
            <Radio value="mobile">Mobile</Radio>
          </Radio.Group>
        </Form.Item>

        {selectedOption && (
          <Form.Item
            label={
              selectedOption === "acknowledgement"
                ? "Enter Acknowledgement ID"
                : "Enter Mobile Number"
            }
            className="centered-input"
          >
            <Input
              placeholder={
                selectedOption === "acknowledgement"
                  ? "Ack ID"
                  : "Mobile Number"
              }
              value={inputValue}
              onChange={handleInputChange}
              className="input-small"
            />
          </Form.Item>
        )}
        {selectedOption && (
          <Form.Item className="centered-button">
            <Button type="primary" htmlType="submit" disabled={!inputValue}>
              Submit
            </Button>
          </Form.Item>
        )}
      </Form>

      <Row gutter={16}>
        {results.map((item, index) => (
          <Col span={24} key={index}>
            <Card
              title={`Acknowledgement ID: ${item.ack_id}`}
              bordered={true}
              className="result-card"
            >
              <div className="card-item">
                <span className="label">Name:</span>
                <span className="value">{item.name}</span>
              </div>
              <div className="card-item">
                <span className="label">Mobile:</span>
                <span className="value">{item.mobile}</span>
              </div>
              <div className="card-item">
                <span className="label">Constituency:</span>
                <span className="value">{item.constituency_name}</span>
              </div>
              <div className="card-item">
                <span className="label">District:</span>
                <span className="value">{item.district_name}</span>
              </div>
              <div className="card-item">
                <span className="label">Mandal:</span>
                <span className="value">{item.mandal_name}</span>
              </div>
              <div className="card-item">
                <span className="label">Village:</span>
                <span className="value">{item.village}</span>
              </div>
              <div className="card-item">
                <span className="label">Subject:</span>
                <span className="value">{item.subject}</span>
              </div>
              <div className="card-item">
                <span className="label">Status:</span>
                <span className="value">{item.pms_status}</span>
              </div>
              <div className="card-item">
                <span className="label">Attache:</span>
                <span className="value">{item.attache}</span>
              </div>
              <div className="card-item">
                <span className="label">Remarks:</span>
                <span className="value">{item.remarks || "N/A"}</span>
              </div>
              <div className="card-item">
                <span className="label">Created By:</span>
                <span className="value">{item.created_by}</span>
              </div>
              <div className="card-item">
                <span className="label">Department:</span>
                <span className="value">{item.department || "N/A"}</span>
              </div>
              <div className="card-item">
                <span className="label">Issue Location:</span>
                <span className="value">{item.issue_location || "N/A"}</span>
              </div>
              <div className="card-item">
                <span className="label">Updated By:</span>
                <span className="value">{item.updated_by || "N/A"}</span>
              </div>
              <div className="card-item">
                <span className="label">Partner Address:</span>
                <span className="value">{item.ptnr_address}</span>
              </div>

              {item.files && item.files.length > 0 && (
                <div className="card-item">
                  <span className="label">Files:</span>
                  <span className="value">
                    {item.files.map((file, idx) => (
                      <a
                        href={file}
                        target="_blank"
                        rel="noopener noreferrer"
                        key={idx}
                      >
                        File {idx + 1}
                      </a>
                    ))}
                  </span>
                </div>
              )}
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default AssigneSearch;
